import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 600,
    autoplay: true,
    margin: 10,
    navText: ['&#8249', '&#8250;'],
    items: 4,
    responsive: {
      0: {
        items: 1
      },
      690: {
        items: 2
      },
      930: {
        items: 3
      }
    },
    nav: false
  }

  images: any[] = [
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-tratamento-sintomas-e-sequelas-pos-covid.jpg",
      "title": "Sintomas e Sequelas Pós Covid",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Tratamento de Sintomas e Sequelas Pós Covid-19"
    },
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-exame-de-espirometria.jpg",
      "title": "Exame de Espirometria",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Exame de Espirometria"
    },
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-tratamento-asma.jpg",
      "title": "Asma",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Tratamento de asma"
    },
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-tratamento-rinite-e-sinusite.jpg",
      "title": "Rinite e Sinusite",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Tratamento de Rinite e Sinusite"
    },
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-tratamento-dpoc-enfisema.jpg",
      "title": "DPOC / Enfisema Pulmonar",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Tratamento de DPOC ou Enfisema Pulmonar"
    },
    
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-tratamento-fibrose-pulmonar.jpg",
      "title": "Fibrose Pulmonar",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Tratamento de Fibrose Pulmonar"
    },
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-tratamento-embolia-pulmonar.jpg",
      "title": "Embolia Pulmonar",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Tratamento de Embolia Pulmonar"
    },
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-tratamento-tabagismo.jpg",
      "title": "Tabagismo",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Tratamento de Tabagismo"
    }, 
    {
      "link": "dra-vanessa-lago-pneumologista-em-sao-joao-da-boa-vista-tratamento-ronco-e-apneia-do-sono.jpg",
      "title": "Ronco e Apneia do Sono",
      "description": "Dra Vanessa Lago, médica pneumologista em São João da Boa Vista. Tratamento de Ronco e Apneia do Sono"
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
